import { Switch, Route, withRouter } from 'react-router-dom';
import VoucherBook from '@nkr/views/voucher-book';

const AdminVoucherBookRoutes = (params) => {
    let url = params.url;

    return (
        <Switch>
            <Route path={`${url}/generate`} render={() => <VoucherBook subTabKey='GENERATE' />} />
            <Route path={`${url}`} render={() => <VoucherBook subTabKey='GENERATE' />} />
        </Switch>
    );
}

export default withRouter(AdminVoucherBookRoutes);
